import React from 'react'
import { AdiccionesDetalleOrdenElementos } from '../../ingreso/AdiccionesDetalleOrdenElementos'

export const InformacionAdiccionesMenu = (props) => { 
  return (
    <AdiccionesDetalleOrdenElementos gestion={true} disabled={props.disabled} onCloseModalAuditar={props.onCloseModalAuditar} />
  )
}
